import { smallScreen } from '../../variables/media';

const initClearOnScroll = () => {
  if (smallScreen('max')) {
    const phoneBar = document.querySelector('.header-phone-bar');
    const searchBar = document.querySelector('.header-search-bar-sm');
    const navBar = document.querySelector('.navbar-main');
    const topBar = document.querySelector('.topbar-customblock');
    let scrolling = false;
    window.addEventListener('scroll', e => {
      if (window.pageYOffset === 0) {
        scrolling = false;
        display([phoneBar, searchBar, topBar], 'block');
        navBar.classList.remove('navbar-main-fixed');
      } else if (!scrolling) {
        scrolling = true;
        display([phoneBar, searchBar, topBar], 'none');
        navBar.classList.add('navbar-main-fixed');
      }
    });
  }
};

const display = (elements: Element[], type: string) => {
  for (const element of elements) {
    element.setAttribute('style', `display: ${type}`);
  }
}

export default initClearOnScroll;
